'use client'
import React from 'react';

import { useDispatch } from 'react-redux';
// import { RESET, sendVerificationEmail } from '@/app/GlobalRedux/features/auth/authSlice1';

import styling from './UserNotVerified.module.scss';
import { useSendVerificationEmailMutation } from '@/app/GlobalRedux/features/auth/authApi';
import { resetAuthState } from "@/app/GlobalRedux/features/auth/authSlice";


const UserNotVerified = () => {
  const dispatch = useDispatch();
  const [sendVerificationEmail] = useSendVerificationEmailMutation();

  const reSendEmail = async () => {
   const response = await sendVerificationEmail(undefined).unwrap();
   dispatch(resetAuthState(response.user));
 };
 
  return (
    <div className={styling.container}>
      <h2 className={styling.title}>Your account is unverified!</h2>
      <p className={styling.message}>
        To access all features, please verify your account by checking your Gmail inbox for a verification link. 
      </p>
      <p className={styling.note}>
        Didn’t receive the email? Check your spam folder or 
        <span onClick={reSendEmail} className={styling.resendLink}> click here to resend.</span>
      </p>
    </div>
  );
}

export default UserNotVerified;
